import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelineTerminateCircuitModel
    //action
    , resetWirelineTerminateCircuitForm
    , setSubscriptionDetails
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-terminate-circuit.settings';

export const terminateCircuitModelAInitialState = wirelineTerminateCircuitModel;

const defaultState = () => ({
    subscription: {}
    , formSubmitted: false
});

const initialState = defaultState();

export const wirelineTerminateCircuitActions = {
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;

        if (value === '') {
            resetForm(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineTerminateCircuitFormA.circuitId) {
                resetForm(dispatch);
                dispatch(actions.change('wirelineTerminateCircuitFormA.circuitCode', value));
                dispatch(actions.change('wirelineTerminateCircuitFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
            }
        }
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineTerminateCircuitFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineTerminateCircuitFormA.wireLineApproverId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.EmployeeId != wirelineTerminateCircuitFormA.employeeId) {
                dispatch(actions.change('wirelineTerminateCircuitFormA.employeeEmail', value));
                dispatch(actions.change('wirelineTerminateCircuitFormA.wireLineApproverId', obj.EmployeeId));
            }
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineTerminateCircuitFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineTerminateRequest: {
                ...wirelineTerminateCircuitFormA
                , requestInBehalfId: userData.requestInBehalfId
                , terminateDate: date
            }
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetWirelineTerminateCircuitForm: () => (dispatch) => {
        resetForm(dispatch);
    }
}

function resetForm(dispatch) {
    dispatch(actions.reset('wirelineTerminateCircuitFormA'));
    dispatch({ type: setFormSubmitted, data: false });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}